export class FrontEndError {
    status: number;
    paymentValidationType: string;
    message: string;
    createdDate: Date;

    constructor(props?: { [key in keyof FrontEndError]?: FrontEndError[key] }) {
        Object.assign(this, props);
    }
}